export const paymentInfo = 'paymentInfo'
export const paymentType = 'paymentType'
export const leavePayment = 'leavePayment'
